import { authConstants } from "../../constants";

export function auth(state={}, action) {
  const { user } = state;
  switch (action.type) {
    case authConstants.LOGIN_REQUEST:
      return { isLoggingIn: true };
    case authConstants.LOGIN_SUCCESS:
    case authConstants.LOGIN_FAILURE:
    case authConstants.LOGOUT:
      return {};
    case authConstants.GET_USER_REQUEST:
      return { isGettingUser: true };
    case authConstants.GET_USER_SUCCESS:
      return { user: action.payload.data };
    case authConstants.GET_USER_FAILURE:
      return {};
    case authConstants.CHANGE_PASSWORD_REQUEST:
      return {
        user,
        isChangingPassword: true,
      };
    case authConstants.CHANGE_PASSWORD_SUCCESS:
    case authConstants.CHANGE_PASSWORD_FAILURE:
      return { user };
    default:
      return state;
  }
}